export const paymentListValue =[
    {id:'cash',name:'Готівка'},
    {id:'card',name:'Банківська картка'}
]